import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';

class PortfolioInternationalPreciousMetalsController implements angular.IOnInit {

  public preciousMetalsHeight: any;
  public preciousMetalsItems: any;
  public preciousMetalsTotal: any = 0;
  public selectedCurrency: string;


  public preciousMetalsPieChart : any;
  public preciousMetalsPieChartOptions : any;
  public preciousMetalsPieChartData : any;


  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService : portfolioSelectorService,
              private $timeout: ng.ITimeoutService, $scope: angular.IScope, private notifyjs) {
    var that = this;


    this.portfolioSelectorService.registerCallback('portfolio.international.preciousmetals', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

  }

  $onInit() {
    this.updateData();
  }

  public formatCurrency(currencyCode: string) {
    if(!this.portfolioSelectorService.isLoading){
      return this.portfolioUtilities.formatCurrency(currencyCode);
    }else{
      return "";
    }
  }

  getPreciousMetalPercentage(preciousMetal: any) {
    return (preciousMetal.marketValueDisplayCurrency / this.preciousMetalsTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }

  public initialisePieChart () {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.preciousMetalsPieChart = echarts.init(document.getElementById('precious-metals-pie-chart'));
    that.preciousMetalsPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color: ['#ffa500', '#ffb732', '#ffc966'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.preciousMetalsPieChartData
      }

    }
    that.preciousMetalsPieChart.setOption(that.preciousMetalsPieChartOptions);

  }

  updateData() {
    let that = this;
    // precious metal data
    this.selectedCurrency = this.portfolioSelectorService.getSelectedCurrency()
    this.portfolioSelectorService.setIsLoading(true);
    that.portfolioRepo.getPortfolioPreciousMetalItems(this.selectedCurrency, 'INTERNATIONAL', this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        that.preciousMetalsItems = val.data;

        that.scrollToElement('preciousMetals');

        that.preciousMetalsPieChartData = new Array();

        for (var s of that.preciousMetalsItems) {
          that.preciousMetalsTotal += s.marketValueDisplayCurrency;

          that.preciousMetalsPieChartData.push({
            name : s.preciousMetalItem.name,
            value : s.marketValueDisplayCurrency
          });
        }
        this.portfolioSelectorService.setIsLoading(false);

      })
      .catch( (err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The precious metals data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
  }
}


export const portfolioInternationalPreciousMetals: angular.IComponentOptions = {
  template: require('../portfolio.international.preciousmetals/portfolio.international.preciousmetals.html'),
  controller: PortfolioInternationalPreciousMetalsController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.international/portfolio.international.preciousmetals/portfolio.international.preciousmetals.ts